import { resolve } from 'acast-www-utils';

export default (episode, category) => {
  return (
    resolve(episode, 'data.conditions', []).filter(condition => condition.category === category)
      .length > 0
  );
};
